import script from "./ApiDatatableMixin.vue?vue&type=script&lang=js"
export * from "./ApiDatatableMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__